import { render, staticRenderFns } from "./TrapezSOR.vue?vue&type=template&id=cd6e8e10&"
import script from "./TrapezSOR.vue?vue&type=script&lang=js&"
export * from "./TrapezSOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports